module.exports = __webpack_public_path__ + "img/p5.0bbf012d.png";